import {store} from '../../store/global-store';

const openPreviewMixin = {
    methods: {
        subscribeOpenPreview() {
            store.subscribe((mutation) => {
                if (mutation.type === 'openPreview') {
                    this._openPreview(mutation.payload.previewUrl);
                }
            });
        },

        _openPreview(url) {
            location.href = url;
        },
    },

    mounted() {
        this.subscribeOpenPreview();
    },
};

export default openPreviewMixin;
